/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import {
    LayoutDashboard,
    BarChart2,
    BellRing,
    FileBarChart,
} from 'lucide-react';

const DASHBOARD_DETAILS = [
    { icon: <LayoutDashboard className="w-5 h-5" />, title: "Multi-utility, multi-site view", desc: "Electricity, water, gas and solar across every building — locally or remotely, from any device." },
    { icon: <BarChart2 className="w-5 h-5" />, title: "Time-stamped usage data", desc: "Peak, shoulder and off-peak visibility with comparative trend reporting built in." },
    { icon: <BellRing className="w-5 h-5" />, title: "Proactive alerting", desc: "Instant notifications for high usage, out-of-hours consumption, and sensor faults." },
    { icon: <FileBarChart className="w-5 h-5" />, title: "Automated compliance reports", desc: "NABERS, Green Star, ESG and NCC reports scheduled and delivered automatically." },
];

const DASHBOARD_BARS = [40, 55, 45, 90, 60, 50, 75, 55, 42, 80, 48, 38, 52, 70];

const DASHBOARD_SITES = [
    { name: "Sydney City · 8 sites", val: "8.2 kWh", online: true },
    { name: "Melbourne CBD · 6 sites", val: "5.1 kWh", online: true },
    { name: "Brisbane North · 4 sites", val: "2.8 kWh", online: false },
    { name: "Perth Industrial · 6 sites", val: "0.3 kWh", online: true },
];

const getBarColor = (h) => {
    if (h > 80) return 'bg-[#fbb93e]';
    if (h > 50) return 'bg-[#459ca5]';
    return 'bg-[#459ca5]/30';
};

const ActionSection = () => {
    return (
        <section id="dashboard" className="w-full py-20 lg:py-12">
            <div className="max-w-[1440px] mx-auto px-6 gap-16 items-center lg:max-w-screen-xl">
                <span className="text-theme-teal font-bold tracking-[0.2em] uppercase text-sm">SEE IT IN ACTION</span>
                <h2 className="mt-4 text-3xl md:text-5xl font-bold text-black tracking-tight dark:text-white">One dashboard. Every site. Total control.</h2>
                <p className="mt-6 text-gray-400 font-light leading-relaxed mb-12 base lg:text-xl">The Nube iO portfolio dashboard gives every stakeholder exactly what they need — clear data, live alerts, and compliance reports, all in one place.</p>
            </div>

            <div className="max-w-[1440px] mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center lg:max-w-screen-xl ">

                <div className="space-y-6">
                    {DASHBOARD_DETAILS.map((item, idx) => (
                        <div key={idx} className="flex gap-4">
                            <div className="w-10 h-10 flex-shrink-0 rounded-md bg-theme-teal/20 text-[#459ca5] flex items-center justify-center">
                                {item.icon}
                            </div>
                            <div>
                                {(item.title) && (
                                    <h3 className="text-xl font-bold text-gray-900 mb-1 text-black text-base lg:text-lg dark:text-theme-teal">
                                        {item.title}
                                    </h3>
                                )}
                                {(item.desc) && (
                                    <p className="text-gray-400 leading-relaxed font-light">
                                        {item.desc}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="bg-[#0f2830] rounded-2xl p-6 border border-[#459ca5]/20 shadow-xl lg:mt-12 ">
                    <div className="flex justify-between items-center mb-6">
                        <span className="text-[11px] font-bold text-white/70 uppercase">Portfolio Overview</span>
                        <span className="text-[10px] text-white/30">Live · 2026</span>
                    </div>

                    <div className="grid grid-cols-3 gap-2 mb-6">
                        <div className="bg-white/5 rounded-lg p-3">
                            <p className="text-[9px] text-white/40 uppercase mb-1">Total Energy</p>
                            <p className="text-white font-bold text-lg">16.4 <span className="text-[10px] font-normal opacity-60">kWh</span></p>
                            <p className="text-[9px] text-[#5cc98a]">↓ 13.8%</p>
                        </div>
                        <div className="bg-white/5 rounded-lg p-3">
                            <p className="text-[9px] text-white/40 uppercase mb-1">Active Sites</p>
                            <p className="text-white font-bold text-lg">24</p>
                            <p className="text-[9px] text-[#5cc98a]">↑ 2 this month</p>
                        </div>
                        <div className="bg-white/5 rounded-lg p-3">
                            <p className="text-[9px] text-white/40 uppercase mb-1">Active Alerts</p>
                            <p className="text-white font-bold text-lg">3</p>
                            <p className="text-[9px] text-[#fc6833]">↑ needs review</p>
                        </div>
                    </div>

                    <p className="text-[9px] text-white/30 mb-2">Energy usage — last 14 days</p>
                    <div className="flex items-end gap-1 h-16 mb-6">
                        {DASHBOARD_BARS.map((h, i) => (
                            <div
                                key={i}
                                className={`flex-1 rounded-sm ${getBarColor(h)}`}
                                style={{ height: `${h}%` }}
                            />
                        ))}
                    </div>

                    <div className="space-y-1">
                        {DASHBOARD_SITES.map((site, i) => (
                            <div key={i} className="flex items-center justify-between p-2 rounded bg-white/5">
                                <span className="text-[10px] text-white/60">{site.name}</span>
                                <div className="flex items-center">
                                    <div className={`w-1.5 h-1.5 rounded-full mx-2 ${site.online ? 'bg-[#5cc98a]' : 'bg-[#fbb93e]'}`} />
                                    <span className="text-[10px] text-white/45">{site.val}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ActionSection;
